module.exports = __webpack_public_path__ + "static/media/coin3.838bcbc7.webp";